var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


var start = cal.moment(start),
    startOfWeekOfStart = cal.moment(start).startOf("isoWeek"),
    endOfWeekOfStart = cal.moment(start).endOf("isoWeek"),
    startOfMonth = cal.moment(start).startOf("month"),
    startOfFirstWeekOfMonth = cal.moment(startOfMonth).startOf("isoWeek"),
    endOfFirstWeekOfMonth = cal.moment(startOfFirstWeekOfMonth).endOf("isoWeek"),
    end = cal.moment(cal.options.position.end),
    today = cal.moment();
;
__p += ' <ul class="gp-calendar__container__controls cf"><li class="gp-calendar__date ' +
__e( today.isSame(start, 'day') ? 'gp-calendar__date--today' : '' ) +
'" data-content-standard="' +
__e( today.format('D/M/YY') ) +
'" ';
 if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { ;
__p += ' data-content-compact="&nbsp" ';
 } else { ;
__p += ' data-content-compact="' +
__e( today.isSame(start, 'day') ? start.format('[TODAY,] D MMMM YYYY') : start.format('dddd[,] D MMMM YYYY') ) +
'" ';
 } ;
__p += ' ></li><li class="gp-calendar__blurb--responsive" style="';
 if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { ;
__p += 'display:none';
 };
__p += '">Showing Times For:</li><li class="gp-calendar__date-dd"><select class="no-select field field--dd week" style="';
 if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { ;
__p += 'display:none;';
 };
__p += '"> ';

            var startOfWeek = cal.moment(startOfFirstWeekOfMonth),
                endOfWeek = cal.moment(endOfFirstWeekOfMonth);
            ;
__p += ' ';
 while (startOfWeek.isSame(startOfFirstWeekOfMonth) || startOfWeek.isSame(start, "month")) { ;
__p += ' <option value="' +
__e( startOfWeek.format('YYYY-MM-DD') ) +
'" ' +
__e( startOfWeek.isSame(startOfWeekOfStart) ? "selected" : "") +
'> ' +
__e( startOfWeek.format("D MMMM") ) +
' - ' +
__e( endOfWeek.format("D MMMM") ) +
' </option> ';

                startOfWeek = startOfWeek.add(1, "weeks");
                endOfWeek = endOfWeek.add(1, "weeks");
                ;
__p += ' ';
 } ;
__p += ' </select> ';
 if(cal.prevDate(end).endOf('day') > today.endOf('day')) { ;
__p += ' </li><li class="js-gp-calendar-arrow-left gp-calendar__btn gp-calendar__arrow gp-calendar__arrow--left" data-direction="prev" data-date="' +
__e( cal.prevDate(start).format('YYYY-MM-DD') ) +
'" style="';
 if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { ;
__p += 'pointer-events: none;background-color: unset;';
 };
__p += '"><i class="icon general-arrow-pag-left" style="';
 if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { ;
__p += 'display:none;';
 };
__p += '"></i> ';
 } ;
__p += ' </li><li class="js-gp-calendar-arrow-right gp-calendar__btn gp-calendar__arrow gp-calendar__arrow--right" data-direction="next" data-date="' +
__e( cal.nextDate(start).format('YYYY-MM-DD') ) +
'" style="';
 if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { ;
__p += 'pointer-events: none;background-color:unset;';
 };
__p += '"><i class="icon general-arrow-pag-right" style="';
 if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { ;
__p += 'display:none;';
 };
__p += '"></i></li></ul> ';
 if(useReasons) { ;
__p += ' <div class="gp-calendar__container__reason"><select class="no-select form-control field" id="reason_select"><option value="" selected="selected">- Select ' +
__e( reasonLabel ) +
' -</option></select></div><div class="gp-calendar__container__vehicle_quantity"><select class="no-select form-control field" id="vehicle_quantity_select"><option value="" selected="selected">Please select number of vehicles</option></select></div> ';
 } ;


}
return __p
};

/*
original source:

<%
var start = cal.moment(start),
    startOfWeekOfStart = cal.moment(start).startOf("isoWeek"),
    endOfWeekOfStart = cal.moment(start).endOf("isoWeek"),
    startOfMonth = cal.moment(start).startOf("month"),
    startOfFirstWeekOfMonth = cal.moment(startOfMonth).startOf("isoWeek"),
    endOfFirstWeekOfMonth = cal.moment(startOfFirstWeekOfMonth).endOf("isoWeek"),
    end = cal.moment(cal.options.position.end),
    today = cal.moment();
%>

<ul class="gp-calendar__container__controls cf">
    <li class="gp-calendar__date <%- today.isSame(start, 'day') ? 'gp-calendar__date--today' : '' %>"
        data-content-standard="<%- today.format('D/M/YY') %>"
        <% if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { %>
        data-content-compact="&nbsp"
        <% } else { %>
        data-content-compact="<%- today.isSame(start, 'day') ? start.format('[TODAY,] D MMMM YYYY') : start.format('dddd[,] D MMMM YYYY') %>"
        <% } %>
    >

    <li class="gp-calendar__blurb--responsive" style="<% if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { %>display:none<% }%>">
        Showing Times For:

    <li class="gp-calendar__date-dd">
        <select class="no-select field field--dd week" style="<% if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { %>display:none;<% }%>">
            <%
            var startOfWeek = cal.moment(startOfFirstWeekOfMonth),
                endOfWeek = cal.moment(endOfFirstWeekOfMonth);
            %>
            <% while (startOfWeek.isSame(startOfFirstWeekOfMonth) || startOfWeek.isSame(start, "month")) { %>
                <option value="<%- startOfWeek.format('YYYY-MM-DD') %>" <%- startOfWeek.isSame(startOfWeekOfStart) ? "selected" : ""%>>
                    <%- startOfWeek.format("D MMMM") %> - <%- endOfWeek.format("D MMMM") %>
                </option>
                <%
                startOfWeek = startOfWeek.add(1, "weeks");
                endOfWeek = endOfWeek.add(1, "weeks");
                %>
            <% } %>
        </select>

    <% if(cal.prevDate(end).endOf('day') > today.endOf('day')) { %>
        <li class="js-gp-calendar-arrow-left gp-calendar__btn gp-calendar__arrow gp-calendar__arrow--left" data-direction="prev" data-date="<%- cal.prevDate(start).format('YYYY-MM-DD') %>" style="<% if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { %>pointer-events: none;background-color: unset;<% }%>">
            <i class="icon general-arrow-pag-left" style="<% if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { %>display:none;<% }%>"></i>
    <% } %>
    <li class="js-gp-calendar-arrow-right gp-calendar__btn gp-calendar__arrow gp-calendar__arrow--right" data-direction="next" data-date="<%- cal.nextDate(start).format('YYYY-MM-DD') %>" style="<% if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { %>pointer-events: none;background-color:unset;<% }%>">
        <i class="icon general-arrow-pag-right" style="<% if (reasonForce && (!isReasonSelected || isReasonSelected == "")) { %>display:none;<% }%>"></i>
</ul>
<% if(useReasons) { %>
<div class="gp-calendar__container__reason">
    <select class="no-select form-control field" id="reason_select">
        <option value="" selected>- Select <%- reasonLabel %> -</option>
    </select>
</div>
<div class="gp-calendar__container__vehicle_quantity" >
    <select class="no-select form-control field" id="vehicle_quantity_select">
        <option value="" selected>Please select number of vehicles</option>
    </select>
</div>
<% } %>

*/
